/**
 * Очищает url от технических хеш параметров
 * @param url
 * @returns clear url
 */
export const clearingUrlFromHash = (url: string): string => {
  if (window.clickstreamAnalyticUtilitiesDemo.isDemo) {
    return url.replace(window.clickstreamAnalyticUtilitiesDemo.hash, '');
  }

  return url;
};
